var map = {
	"./007-microphone-1.png": "a9bd",
	"./010-home.png": "5bb2b",
	"./013-document-1.png": "7a8c",
	"./014-document.png": "458c",
	"./015-color-palette.png": "175f",
	"./017-video-camera.png": "c6ddb",
	"./024-like.svg": "5823",
	"./1.svg": "42a2",
	"./155-credit-card.svg": "5329",
	"./2.svg": "f18c",
	"./3.svg": "f870",
	"./4.svg": "b02d",
	"./New Customer.svg": "fed5",
	"./NotOpen.svg": "3091",
	"./Opened.svg": "1004",
	"./Profit.svg": "78e8",
	"./SalesRevenue.svg": "9a98",
	"./Sent.svg": "bac1",
	"./Slack.svg": "8f25",
	"./address.svg": "04f7",
	"./adidas.svg": "b114",
	"./adobe.svg": "14c6",
	"./arrow-growth.svg": "53c7",
	"./arrow-left.png": "c98f",
	"./arrow-left.svg": "aae1",
	"./arrow-right.png": "0207",
	"./arrow-right.svg": "6d18",
	"./bell.svg": "b619",
	"./book-open.svg": "1745",
	"./book.svg": "f594",
	"./briefcase.svg": "5348",
	"./camera.svg": "abe1",
	"./chat.svg": "acc2",
	"./check-circle.svg": "9fef",
	"./clipboard.svg": "6b60",
	"./clock.svg": "77e5",
	"./cloud.svg": "b286",
	"./columns.svg": "a4d32",
	"./documentation.svg": "a1a6",
	"./dollar-circle.svg": "dd0c",
	"./envelope.svg": "6c63",
	"./file.svg": "28b4",
	"./flat.svg": "7786",
	"./google-plus.svg": "db5b",
	"./headphone.svg": "e019",
	"./iconfinder_trello_2317760.svg": "213a",
	"./idea.svg": "ede3",
	"./image.png": "31b0",
	"./image.svg": "5205",
	"./label.png": "cc58",
	"./layers.svg": "bdda",
	"./left-bar.svg": "0fbc",
	"./left.svg": "0384",
	"./logo2.svg": "18fe",
	"./logo3.svg": "1de1",
	"./logo4.svg": "6abb",
	"./logo5.svg": "1166",
	"./logo6.svg": "3b36",
	"./logoIn.svg": "894c",
	"./message.svg": "8d54",
	"./microsoft.svg": "b826",
	"./money-wave.svg": "7663",
	"./paint.svg": "81bb",
	"./protection.svg": "2fc8",
	"./quote-left.png": "b33c",
	"./quote-right.png": "969a",
	"./quote.png": "1f1c",
	"./repeat.svg": "986c",
	"./right.svg": "7383",
	"./setting.svg": "32a0",
	"./shopping-cart.svg": "cbe9",
	"./speed-meter.svg": "1020",
	"./strategy.svg": "e496",
	"./theme.svg": "ad92",
	"./ticket.svg": "f92d",
	"./user.svg": "0756",
	"./users-alt.svg": "3d82",
	"./water-fall.svg": "1657",
	"./wordpress.svg": "dd2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a658";